const Environment = {
  SANDBOX: 'SANDBOX',
  PRODUCTION: 'PRODUCTION'
}

module.exports = Environment;
